import _ from 'lodash';
import globalStore from '$$globalStore';
import constants from '$$helpers/constants';

export default function getCalcForParent(task, column, isBaseline, sumMode, valuesMap) {
  const children = globalStore.getters['tasksModel/getChildByTask'](task.gantt_id, task.id);

  let parentSum = 0;
  let count = 0;
  let parentAverage = 0;
  let result = 0;
  let taskCustomValuesMap = valuesMap;

  if (!valuesMap) {
    if (isBaseline) {
      taskCustomValuesMap = globalStore.getters['baselines/getActiveBaselineUserCustomValuesMap'](task.gantt_id);
    } else {
      taskCustomValuesMap = globalStore.getters['columns/getValuesMapByProjectId'](task.gantt_id);
    }
  }

  _.each(children, task => {
    if (task.type === constants.TASK_TYPES.task || task.type === constants.TASK_TYPES.milestone) {
      let taskCustomValue = 0;

      taskCustomValue = taskCustomValuesMap[`${task.id}-${column.id}`] ? parseFloat(taskCustomValuesMap[`${task.id}-${column.id}`], 10) : 0;
      parentSum += taskCustomValue;

      count++;
    }
    if (task.type === constants.TASK_TYPES.project) {
      parentSum += getCalcForParent(task, column, isBaseline, sumMode, taskCustomValuesMap);
      count++;
    }
  });

  parentAverage = parentSum / count;

  result = sumMode ? parentSum : !_.isNaN(parentAverage) ? parentAverage : 0;

  return Math.round(result * 100) / 100;
}
